<template>
	<div id="header" class="header">
		<div class="header-main main">
			<div class="header-l">
				<a class="logo" :href="homeUrl">
					<img src="../assets/sp_logo.png" alt="">
				</a>
				<ul class="nav-list">
					<li v-for="(item,index) in navList" :key="index">
						<a :class="{'on':tabIndex==index}" :href="item.MenuUrl">{{item.MenuLabel}}</a>
					</li>
				</ul>
			</div>
			<div class="header-r">
				<div class="user-area" v-if="userInfo.IsLogin">
					<span>欢迎您，</span>
					<a class="username" href="javascript:void(0);">{{userInfo.LoginName}}</a>
					<!-- <img class="avatar" src="../assets/avatar.png" alt=""> -->
					<span class="btn-exit" @click="exit">退出</span>
				</div>
				<a v-if="!userInfo.IsLogin" href="/UserAccount/LoginGuide" class="btn-login">登录/注册</a>
			</div>
		</div>
	</div>
</template>
<script>
import { getUserInfo,GetWebHeaderData } from '@/scripts/api.js'
import { setStorage,removeStorage,c_origin,p_origin } from '@/scripts/util.js';
import Cookie from 'js-cookie'
export default {
	data(){
		return{
			navList:[],
			userInfo:{},
			tabIndex:'',
			homeUrl:p_origin,
		}
	},
	created(){
		if(process.env.NODE_ENV=='production'){
			this.UserInfo();
		}else{
			removeStorage('userInfo');
			this.userInfo={
				IsLogin:true,
				// LoginAccountType:1,
				// LoginAccountId: 3666032,
				// UserCode:'p3666032',
				LoginAccountType:2, //1代表个人 2代表企业,
				LoginAccountId: 63773, //63773 63747
				UserCode:'e63773',
				LoginName:'百事可乐',
				Handset: 18900008888,
				IsAuthentication:true,
				IsHasPickJobPermission:false,
				ApiUrl:'http://api.qa.gongkongbpo.com'
			}
			this.initHeadMenu(this.userInfo.LoginAccountId,this.userInfo.LoginAccountType);
			this.homeUrl=p_origin;//this.userInfo.LoginAccountType == 1?p_origin:c_origin;
			setTimeout(()=>{
				setStorage('userInfo',this.userInfo);
				this.$store.commit('setUserInfo',this.userInfo);
			},200);
		}
		if(window.location.href.indexOf('companyCenter.html')>-1 || window.location.href.indexOf('personalCenter.html')>-1){
			this.tabIndex==1;
		}
	},
	methods: {
		UserInfo(){
			getUserInfo().then(res=>{
				//如果是未登录，跳转登录
				if(!res.IsLogin){
					window.location.href='/UserAccount/LoginGuide';
					return;
				}
				var str=res.LoginAccountType == 1?'p':'e';
				// this.userInfo={
				// 	IsLogin:res.IsLogin,
				// 	LoginAccountType:res.LoginAccountType,
				// 	LoginAccountId:res.LoginAccountId,
				// 	LoginName:res.LoginName,
				// 	UserCode:str+res.LoginAccountId,
				// 	ApiUrl:res.ApiUrl,
				// 	WebSiteUrl:res.WebSiteUrl,
				// 	CSiteUrl:res.CSiteUrl
				// }
				this.userInfo={
					...res
				}
				this.userInfo['UserCode']=str+res.LoginAccountId;
				this.initHeadMenu(res.LoginAccountId,res.LoginAccountType);
				setStorage('userInfo',this.userInfo);
				this.$store.commit('setUserInfo',this.userInfo);
			}).catch(err=>{
				//非开发环境就跳转到登录
				if(process.env.NODE_ENV!=='development'){
					window.location.href='/UserAccount/LoginGuide';
				}
			})
		},
		initHeadMenu(id,type){
			GetWebHeaderData({
				platform:'pcweb',
				accountId:id,
				accountType:type,
			}).then(r=>{
				if(r.Result==1){
					this.navList=r.Data.HeaderMenuList || [];
				}
			})
		},
		// getCookie(){
		//     let cookieJson={};
		//     let cookieArr=document.cookie.split('; ');
		//     for (let i = 0; i < cookieArr.length; i++) {
		//         let item=cookieArr[i].split('=');
		//         cookieJson[item[0]]=item[1];
		//     }
		//     return cookieJson;
		// },
		//退出
		exit(){
			var origin=p_origin.substr(p_origin.indexOf('www.')+4);
			Cookie.remove('KCompanyid',{domain:origin});
			Cookie.remove('KCompanyName',{domain:origin});
			Cookie.remove('CompanyIsLogin',{domain:origin});
			Cookie.remove('token',{domain:origin});
			removeStorage('userInfo');
			window.location.href='/UserAccount/UserLogin';
		}
	}
}
</script>
<style lang="scss">
#header {
	position: fixed;
	left: 0;
	top: 0;
	z-index: 9;
	width: 100%;
	background: #fff;
	border-bottom: 1px solid #f75959;
	border-bottom: 1px solid #ccc \0;
	-webkit-box-shadow: 0 0 20px rgba(8,1,3,0.16);
	-moz-box-shadow: 0 0 20px rgba(8,1,3,0.16);
	-o-box-shadow: 0 0 20px rgba(8,1,3,0.16);
	box-shadow: 0 0 20px rgba(8,1,3,0.16);
}

#header .header-main {
	margin: 0 auto;
	height: 68px;
}

#header .header-l {
	float: left;
	overflow: hidden;
}

#header .logo {
	float: left;
	width: 131px;
	height: 37px;
	margin-top: 15px;
}

#header .head-title {
	float: left;
	font-size: 16px;
	color: #999;
	height: 36px;
	line-height: 36px;
	margin-top: 16px;
	margin-left: 10px;
	padding-left: 10px;
	border-left: 1px solid #e5e5e5;
}
#header .nav-list{
	float:left;
	margin-left: 54px;
	overflow: hidden;
	white-space: nowrap;
	li{
		display: inline-block;
		color:#333;
		font-size: 16px;
		margin-right: 40px;
	}
	a{
		display:block;
		color:#333;
		height: 68px;
		line-height: 68px;
		position: relative;
		&.on{
			color: #f75959;
		}
		&.on:after{
			content:'';
			position: absolute;
			left: 0;
			bottom: 0;
			width: 100%;
			height: 2px;
			background-color: #f75959;
		}
	}
	a:hover{
		color:#f75959
	}
}

#header .header-r {
	float: right;
	margin-top: 18px;
}

#header .user-area {
	height: 32px;
	line-height: 32px;
	font-size: 14px;
	color: #999;
}

#header .username {
	font-weight: bold;
	color: #666;
}
#header .avatar{
	display: inline-block;
	width: 50px;
	height: 50px;
	vertical-align: middle;
	margin-left: 10px;
	margin-right: 20px;
}

#header .btn-exit {
	color: #666;
	display: inline-block;
	color: #f75959;
	font-size: 14px;
	line-height: 32px;
	position: relative;
	cursor: pointer;
	margin-left: 20px;
}

#header .btn-exit:after {
	content: "";
	position: absolute;
	left: 50%;
	bottom: 0;
	width: 0px;
	height: 2px;
	background-color: #f00;
	transition: all 0.1s linear;
}

#header .btn-exit:hover {
	color: #f00;
}

#header .btn-exit:hover:after {
	width: 100%;
	left: 0;
}
#header .btn-login{
	display: block;
	text-align: center;
	min-width: 90px;
	background: #f75959;
	border: 1px solid #f75959;
	border-radius: 2px;
	line-height: 24px;
	margin-right: 0;
	font-size: 14px;
	color: #fff;
	line-height: 24px;
}
</style>